/*!
 * FormPage
 */

import Helpers from '../base/helpers.js';

export default class FormPage {
  mhTargets = []; // squared array

  constructor() {
    this.fieldset = document.querySelectorAll('[data-mh="fieldset"]');
    this.inputGroup = document.querySelectorAll('.input-group');

    this._addListeners();
    this._init();
  }

  _init() {
    this._matchHeightByGroup();
    this._focusInputGroup();
  }

  _addListeners() {
    this.throttledMatchHeightGroup = Helpers.Throttle(this._matchHeightByGroup.bind(this), 200);
    window.addEventListener('resize', this.throttledMatchHeightGroup);

    this.throttledMatchHeight = Helpers.Throttle(this._matchHeightByGroup.bind(this), 200);
    window.addEventListener('resize', this.throttledMatchtHeight);
  }

  _focusInputGroup() {
    if (this.inputGroup.length === 0) return;

    document
      .querySelectorAll('.input-group .form-control, .input-group .form-select')
      .forEach((el) => {
        el.addEventListener('focus', () => {
          el.parentElement.classList.add('input-group-focus');
        });

        el.addEventListener('blur', () => {
          el.parentElement.classList.remove('input-group-focus');
        });
      });
  }

  _matchHeightByGroup() {
    if (this.fieldset.length === 0);

    this.fieldset.forEach((container, i) => {
      let elements = Array.from(container.querySelectorAll('[data-mh="tr"]'));
      let item = elements.map((el) => {
        return {
          el,
          height: 0,
        };
      });
      this.mhTargets.push(item);
    });

    for (let i = 0; i < this.mhTargets.length; i++) {
      // remove all height
      this.mhTargets[i].forEach((item) => {
        item.el.style.height = '';
      });
      this._matchHeight(i);
    }
  }

  _matchHeight(idx) {
    this.mhTargets[idx].forEach((item) => {
      const bb = item.el.getBoundingClientRect();
      item.height = bb.height;
    });

    let maxHeight = Math.max(...this.mhTargets[idx].map((item) => item.height));
    this.mhTargets[idx].forEach((item) => {
      item.el.style.height = `${maxHeight}px`;
    });
  }
}
